import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { extractCommonItemProps } from '../../../../../util/layout/layoutPropsExtractor.js';
import '../../../../../util/styles/index.js';
import { mergeProps } from '@react-aria/utils';
import { VALIDATION_STATE_MAP } from '../../FormField/components/Root/constants.js';
import { READ_ONLY_DEFAULT_STYLES, DISABLED_DEFAULT_STYLES } from '../../../shared/constants.js';
import { useGroupContext } from '../../../../Group/GroupContext.js';
import { useAdsStyles } from '../../../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["size", "isDisabled", "isReadOnly", "state", "my"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useControlContainer = function useControlContainer(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    isDisabled = _ref.isDisabled,
    isReadOnly = _ref.isReadOnly,
    state = _ref.state,
    _ref$my = _ref.my,
    my = _ref$my === void 0 ? '8' : _ref$my,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles,
    getInteractiveState = _useAdsStyles.getInteractiveState;
  var isUnderGroup = useGroupContext();
  var CommonItemProps = extractCommonItemProps(rest);
  var containerStyles = mapAdsStyles(_objectSpread(_objectSpread(_objectSpread({}, CommonItemProps), {}, {
    borderColor: 'base.intent',
    border: {
      value: '1'
    },
    borderStyle: 'solid',
    display: 'flex',
    alignItems: 'center',
    borderRadius: {
      value: '8'
    },
    minHeight: size === 'default' ? '44px' : '36px',
    width: '100%',
    px: '12',
    my: my,
    gap: '4'
  }, isReadOnly && _objectSpread({}, READ_ONLY_DEFAULT_STYLES)), isDisabled && _objectSpread({}, DISABLED_DEFAULT_STYLES)));
  if (isUnderGroup) {
    var childGroupClassName = 'child-group';
    containerStyles.className = "".concat(containerStyles.className, " ").concat(childGroupClassName);
  }
  if (isDisabled) {
    return {
      containerProps: containerStyles
    };
  }
  var interactiveStateStyles = getInteractiveState({
    type: 'container',
    within: true,
    intent: state ? VALIDATION_STATE_MAP.get(state) : undefined
  }).adsStyles;
  return {
    containerProps: mergeProps(containerStyles, interactiveStateStyles)
  };
};

export { useControlContainer };
//# sourceMappingURL=useControlContainer.js.map
